---
title: 'Step 4: Configure the Collector'
install_track_title: Installation Guide (Self-Managed)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import PublicLastStepLogInsightsLink from '../_public_last_step_log_insights_link.mdx'

export const APIKeyInstructions = ({ apiKey }) => {
  return apiKey ? (
    <React.Fragment>
      The <code>PGA_API_KEY</code> for the current organization is{" "}
      <code>{apiKey}</code>
    </React.Fragment>
  ) : (
    <React.Fragment>
      The <code>PGA_API_KEY</code> can be found in the pganalyze Settings page
      for your organization, under the API Access tab
    </React.Fragment>
  );
};

export const CollectorDotEnv = ({ apiKey }) => {
  return (
    <CodeBlock language="bash">
      {`PGA_API_KEY=${apiKey}
DB_HOST=your_database_host
DB_NAME=your_database_name
DB_USERNAME=your_monitoring_user
DB_PASSWORD=your_monitoring_user_password`}
    </CodeBlock>
  );
};

## Configuring the collector with Docker

Create your configuration file (e.g. named `pganalyze_collector.env`) with environment variables like this:

<CollectorDotEnv apiKey={props.apiKey} />

Fill in the values step-by-step:

1. <APIKeyInstructions apiKey={props.apiKey} />
2. The `DB_HOST` is the hostname of your PostgreSQL instance (usually `localhost`)
3. The `DB_NAME` is the database on the PostgreSQL server you want to monitor
4. The `DB_USERNAME` and `DB_PASSWORD` should be the credentials of the monitoring user we created in Step 1

## Test snapshot

Then run the following to test the configuration:

```bash
docker run --env-file pganalyze_collector.env quay.io/pganalyze/collector:stable test
```

<PublicOnly>

After a successful test you can now start the collector in the background:

```bash
docker run -d --name pganalyze-collector --env-file pganalyze_collector.env quay.io/pganalyze/collector:stable
```

</PublicOnly>

<PublicLastStepLogInsightsLink />
